export default __webpack_public_path__ + "static/media/billboard_landscape_original.245c72b2.jpg";